(function () {
    'use strict';

    angular.module('fundSwapApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'GLOBAL_URL', '$base64',
        '$urlRouterProvider'];

    function stateConfig($stateProvider, GLOBAL_URL, $base64,
                         $urlRouterProvider) {
        $urlRouterProvider.otherwise("/fund-swap");
        $stateProvider
            .state(
                'fund-swap',
                {
                    url: '/fund-swap/:txnId/:taskId',
                    data: {
                        pageTitle: 'HOÁN ĐỔI QUỸ'
                    },
                    params: {
                        txnId: {
                            squash: true,
                            value: null
                        },
                        taskId: {
                            squash: true,
                            value: null
                        }
                    },
                    views: {
                        'content@': {
                            //templateUrl: GLOBAL_URL + 'partial?uri=ga/fund-swap/layouts/fund-swap',
							templateUrl: GLOBAL_URL + 'partial?uri=ga/pulse/pulse',
                            controller: 'FundSwapController',
                            controllerAs: 'fundSwapCtr'
                        }
                    },
                    resolve: {
                        entity: function (FundSwapService, $stateParams) {
                            if ($stateParams.txnId != null && $stateParams.txnId != undefined) {
								var fundSwap = FundSwapService.get({uri: "get-fund-swap", txnId:$base64.decode($stateParams.txnId)}).$promise;
								return fundSwap;
                            }
                        }
                    }
                })
            .state(
                'fund-swap.one',
                {
                    data: {
                        pageTitle: 'HOÁN ĐỔI QUỸ'
                    },
                    views: {
                        'partial@fund-swap': {
                            templateUrl: GLOBAL_URL
                                + 'partial?uri=ga/fund-swap/layouts/oneToMany'
                        }
                    }
                })
            .state(
                'fund-swap.many',
                {
                    data: {
                        pageTitle: 'HOÁN ĐỔI QUỸ'
                    },
                    views: {
                        'partial@fund-swap': {
                            templateUrl: GLOBAL_URL
                                + 'partial?uri=ga/fund-swap/layouts/manyToOne'
                        }
                    }
                })
    }
})();
